import React from "react";

const Footer = () =>{
    return (
        <footer>
         ©{new Date().getFullYear()}  copyright all rights reserved
        </footer>
    )
}

export default Footer;